"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Input for evaluation of alerts for final price.
 * @author Radek Beran
 */


var FinalPriceAlertsInput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(FinalPriceAlertsInput, _DomainObject_1$Domai);

  /**
   * @param finalPriceValue value of final price
   * @param finalPriceValidation Existing validation (alerts) of {@link FinalProductPrice}.
   * @param family family of product if product is in a family
   * @param familyLeaderFinalPrice final price for family leader (if any exists)
   * @param rules price calculation rules/constraints from release settings; if settings are defined
   * @param releaseItem release item with reference price, purchase price filled
   * @param priceZoneId id of price zone
   */
  function FinalPriceAlertsInput(finalPriceValue, finalPriceValidation, family, familyLeaderFinalPrice, rules, releaseItem, priceZoneId) {
    var _this;

    _classCallCheck(this, FinalPriceAlertsInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FinalPriceAlertsInput).call(this));
    _this.finalPriceValue = finalPriceValue;
    _this.finalPriceValidation = finalPriceValidation;
    _this.family = family;
    _this.familyLeaderFinalPrice = familyLeaderFinalPrice;
    _this.rules = rules;
    _this.releaseItem = releaseItem;
    _this.priceZoneId = priceZoneId;
    return _this;
  }

  return FinalPriceAlertsInput;
}(DomainObject_1.DomainObject);

exports.FinalPriceAlertsInput = FinalPriceAlertsInput;